import { cn } from "@/lib/utils";

/**
 * Enterprise section container matching the reference onboarding screens:
 * a white card with a numbered circle + icon badge header, title and
 * subtitle. Used across the signup wizard and admin console so every
 * screen has the same dense, product-grade visual hierarchy instead of
 * naked fields on a flat background.
 */
export default function SectionCard({ step, icon: Icon, title, subtitle, children, className, action }) {
  return (
    <section className={cn("rounded-xl border border-border bg-card p-6 shadow-sm", className)}>
      <div className="flex items-start justify-between">
        <div className="flex items-start gap-3">
          {step != null && (
            <div className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-primary text-sm font-semibold text-primary-foreground">
              {step}
            </div>
          )}
          {Icon && step == null && (
            <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-accent text-accent-foreground">
              <Icon className="h-4.5 w-4.5" />
            </div>
          )}
          <div>
            <h2 className="font-heading text-base font-semibold leading-tight">{title}</h2>
            {subtitle && <p className="mt-0.5 text-sm text-muted-foreground">{subtitle}</p>}
          </div>
        </div>
        {action}
      </div>
      <div className="mt-5">{children}</div>
    </section>
  );
}
